export default {
    methods: {
        openPassport() {
            /*assign variables to elements*/
            const passportContent = document.querySelector('.p-passport__content');
            const closeIconLoggedIn = document.querySelector('.p-passport__loggedin .p-passport__icon--close');
            const closeIconLoggedOut = document.querySelector('.p-passport__loggedout .p-passport__icon--close');
            const loginTopBar = document.querySelector('.p-passport__loggedin');
            const logoutTopBar = document.querySelector('.p-passport__loggedout');
            const loginContent = document.querySelector('.p-passport__content-loggedin');
            const logoutContent = document.querySelector('.p-passport__content-loggedout');

            /*make two node lists to add event listeners to*/
            const buttonList = document.querySelectorAll(".p-passport__login-button, .p-passport__logout-button");
            const topbarList = document.querySelectorAll(".p-passport__logo, .p-passport__loggedin .p-passport__icon--close, .p-passport__loggedout .p-passport__icon--close");
            const loginButton = document.querySelectorAll(".loginButton");

            let valueArray = [
                {elem : passportContent, disp : 'flex'},
                {elem : closeIconLoggedIn, disp : 'block'},
                {elem : closeIconLoggedOut, disp : 'block'}
            ]

            for(var i = 0; i<valueArray.length; i++) {
                valueArray[i].elem.style.display = valueArray[i].elem.style.display === valueArray[i].disp ? '' : valueArray[i].disp;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/passport.js